import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Typography,
  Grid,
} from "@mui/material";
import { postFulfillOrder } from "../api/api";
import axios from "axios";
import { toast } from "react-toastify";

const shippingCarriers = [
  "Correos / Correos Express",
  "SEUR",
  "MRW",
  "Nacex",
  "Tipsa",
  "Envialia",
  "DHL Express Spain",
  "UPS Spain",
  "FedEx / TNT",
  "GLS Spain",
  "InPost",
  "DB Schenker",
  "Blue Dart",
  "Grupo Carreras",
  "Logista",
  "Grupo Sesé",
  "Kuehne + Nagel",
  "Rhenus Logistics",
  "Alfil Logistics",
  "Transaher",
  "Other",
];

function FulfillmentDialogueBox({
  open,
  onClose,
  onConfirm,
  selectedFullfillOrder,
  setOpenFulfillmentDialog,
  loading,
  setLoading,
  handleGetOrdersList,
  setTotalOrdersData,
  setNextCursor,
  setOrderInfoList,
  refreshParent,
}) {
  const userInfo =
    sessionStorage.getItem("loggedInUserData") &&
    JSON.parse(sessionStorage.getItem("loggedInUserData"));
  const loggedInDoctorInfo = userInfo && userInfo;
  const [shippingCarrier, setShippingCarrier] = useState("");
  const [trackingId, setTrackingId] = useState("");

  console.log(selectedFullfillOrder, "::>>selectedFullfillOrder>>");
  console.log(shippingCarrier, "::>>shippingCarrier>>");

  const handleFulfillOrder = async () => {
    if (!trackingId || !shippingCarrier) {
      toast.error("Please enter details");
      return;
    }
    let reqBody = {
      fulfillment_order_gid:
        selectedFullfillOrder?.fulfillment_order_gids &&
        selectedFullfillOrder?.fulfillment_order_gids[0],
      tracking_number: trackingId, //"1Z999AA10123456784",
      tracking_company: shippingCarrier,
      compounder_id: loggedInDoctorInfo?.compounder_id,
      order_name: selectedFullfillOrder?.name,
    };
    console.log(reqBody, "::>>reqBodyfullFill>>");
    setLoading(true);

    try {
      const response = await axios.post(postFulfillOrder, reqBody);
      setLoading(false);

      if (response.status === 200) {
        setTotalOrdersData("");
        setNextCursor("");
        setOrderInfoList([]);
        setTrackingId("");
        setShippingCarrier("");
        setOpenFulfillmentDialog(false);
        setLoading(false);
        handleGetOrdersList("true");
        refreshParent();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching orders:", error);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="fulfillmentMainDialogue"
    >
      <DialogTitle>Confirm Fulfillment</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to fulfill the order for:</Typography>
        <Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>
          {selectedFullfillOrder?.name || "Customer Name"}{" "}
          {/* Customize based on your row data */}
        </Typography>
        <div className="mt-3 fulfillmentDialogue">
          <Typography variant="h6" gutterBottom className="headingTrack">
            Tracking information
          </Typography>
          <Grid container spacing={2} className="fulfillmentDialogueGrid">
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Tracking number
              </Typography>

              <TextField
                fullWidth
                label="Tracking number"
                variant="outlined"
                size="small"
                onChange={(e) => setTrackingId(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Shipping carrier
              </Typography>
              <FormControl fullWidth>
                <InputLabel className="pt-0 selectLabel">
                  Shipping carrier
                </InputLabel>
                <Select
                  value={shippingCarrier}
                  label="Shipping carrier"
                  onChange={(e) => setShippingCarrier(e.target.value)}
                  size="small"
                >
                  {shippingCarriers &&
                    shippingCarriers.map((carrier) => (
                      <MenuItem key={carrier} value={carrier}>
                        {carrier}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            {shippingCarrier == "Other" && (
              <Grid size={{ xs: 12, md: 12 }}>
                <Typography variant="h6" gutterBottom>
                  Tracking URL
                </Typography>

                <TextField
                  fullWidth
                  size="small"
                  label="Tracking URL"
                  variant="outlined"
                  sx={{ mb: 3 }}
                />
              </Grid>
            )}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" className="cancelButton">
          Cancel
        </Button>
        <Button
          onClick={() => handleFulfillOrder()}
          color="primary"
          variant="contained"
          className="mainCommonButton"
        >
          Confirm Fulfill
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FulfillmentDialogueBox;
